// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.input-field[data-v-89477f02] {\r\n    width: 120px;\n}\n.form-row[data-v-89477f02]{\r\n    display: flex;\r\n    align-items: flex-end\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
